// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__rzb5W","rootSmall":"AddTileButton_rootSmall__1ARXB"};